export const ROW_TYPE_TRANCHE = 'tranche';
export const ROW_TYPE_DEAL = 'deal';
